export default __webpack_public_path__ + "static/media/pexels-andrea-piacquadio-3812739.3324ad8f.jpg";